import React, { useState } from 'react';

const PASSWORD = 'Claude';
const SESSION_KEY = 'nt_auth';

export function isAuthenticated(): boolean {
  return localStorage.getItem(SESSION_KEY) === '1';
}

export default function PasswordGate({ onAuth }: { onAuth: () => void }) {
  const [value, setValue] = useState('');
  const [shake, setShake] = useState(false);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (value === PASSWORD) {
      localStorage.setItem(SESSION_KEY, '1');
      onAuth();
    } else {
      setShake(true);
      setValue('');
      setTimeout(() => setShake(false), 450);
    }
  };

  return (
    <div className="gate">
      <form onSubmit={submit} className={shake ? 'gate-card shake' : 'gate-card'}>
        <span className="wordmark big">NEWSTECH<span className="wordmark-tick">▼</span></span>
        <span className="subtitle">short-side news desk</span>
        <input
          type="password"
          value={value}
          autoFocus
          placeholder="passphrase"
          onChange={e => setValue(e.target.value)}
          className="gate-input"
        />
      </form>
    </div>
  );
}
